import React from "react";

/**
 * Props: 
 *   options: { id: String / Number, name: String / Number }
 *   name: String
 */

var StyledSelect = React.createClass({
  createOptions: function(){
    var options = this.props.options || [];
    return options.map(function(item){
      return <option value={ item.id }>{item.name}</option>
    });
  },

  handleChange: function(e){
    this.props.onChange(e.target.value);
  },

  render: function(){
    return (
      <div className='c_styled-select'>
        <div className='select-wrapper'>
          <select name={ this.props.name || "" } onChange={ this.handleChange }>
            { this.createOptions() }
          </select>
        </div>
      </div>
    )
  }
});

module.exports = StyledSelect;


// WEBPACK FOOTER //
// ./components/ui-components/styled-select.js